import React from "react";

export default function Close() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4009 7.61328C24.1518 7.3636 23.8136 7.22329 23.4609 7.22329C23.1082 7.22329 22.77 7.3636 22.5209 7.61328L16.0009 14.1199L9.48094 7.59994C9.23183 7.35027 8.89363 7.20996 8.54094 7.20996C8.18825 7.20996 7.85005 7.35027 7.60094 7.59994C7.08094 8.11994 7.08094 8.95994 7.60094 9.47994L14.1209 15.9999L7.60094 22.5199C7.08094 23.0399 7.08094 23.8799 7.60094 24.3999C8.12094 24.9199 8.96094 24.9199 9.48094 24.3999L16.0009 17.8799L22.5209 24.3999C23.0409 24.9199 23.8809 24.9199 24.4009 24.3999C24.9209 23.8799 24.9209 23.0399 24.4009 22.5199L17.8809 15.9999L24.4009 9.47994C24.9076 8.97328 24.9076 8.11994 24.4009 7.61328Z"
        fill="white"
      />
    </svg>
  );
}
